import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
// //开启扩展日志1
import asf from '@/utils/consolePuls.js';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enquireScreen from '@/utils/device';
import { mapActions } from 'vuex';
export default {
  data: function data() {
    return {
      locale: zhCN
    };
  },
  created: function created() {
    // if(localStorage.getItem('pro__Access-Token')){
    //   let userInfo = JSON.parse(localStorage.getItem('pro__Login_Userinfo'))
    //   console.log('queryMapContent', localStorage.getItem('pro__Login_Userinfo'))
    //   queryMapContent(userInfo.id).then(res=>{
    //     console.log('res',res)
    //   })
    // }
    this.$store.commit('changeProject', window.localStorage.getItem('projectCode'));

    if (process.env.NODE_ENV != 'development') {
      asf.ConsolePlus.init();
      asf.ConsolePlus.setLevel(asf.ConsolePlus.WARN);
    }

    if (localStorage.getItem('bgLight') == 'true') {
      this.$store.commit('changeBg', true);
    } else if (localStorage.getItem('bgLight') == 'false') {
      this.$store.commit('changeBg', false);
    } else {
      this.$store.commit('changeBg', false);
    }

    var that = this;
    enquireScreen(function (deviceType) {
      // tablet
      if (deviceType === 0) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile');
        that.$store.dispatch('setSidebar', false);
      } else if (deviceType === 1) {
        // mobile
        that.$store.commit('TOGGLE_DEVICE', 'mobile');
        that.$store.dispatch('setSidebar', false);
      } else {
        that.$store.commit('TOGGLE_DEVICE', 'desktop');
        that.$store.dispatch('setSidebar', true);
      }
    });
    that.getMapData();
  },
  methods: _objectSpread({}, mapActions(['getMapData']))
};